import React from 'react';
import PropTypes from 'prop-types';

const renderLabel = (status) => {
  switch (status) {
    case 'employer_draft':
      return <span className="badge bg-default me-5">Employer Draft</span>;
    case 'employer_requested_matching':
      return <span className="badge bg-primary me-5">Employer Requested Matching</span>;
    case 'clora_matching':
      return <span className="badge rounded-pill bg-info me-5">Clora Matching</span>;
    case 'clora_matched':
      return <span className="badge rounded-pill bg-success me-5">Matched</span>;
    case 'executed_agreement':
      return <span className="badge rounded-pill bg-success me-5">Executed Agreement</span>;
    case 'work_started':
      return <span className="badge rounded-pill  bg-success me-5">Work Started</span>;
    case 'work_completed':
      return <span className="badge rounded-pill bg-success me-5">Work Completed</span>;
    case 'on_hold':
      return <span className="badge rounded-pill bg-warning me-5">On Hold</span>;
    case 'closed':
      return <span className="badge rounded-pill bg-danger me-5">Closed</span>;
    case 'submitted':
      return <span className="text text-info label-text me-5">Submitted</span>;
    case 'edits_requested':
      return <span className="text-danger label-text me-5">Feedback Given</span>;
    case 'drafting':
      return <span className="text-primary label-text me-5">In Progress</span>;
    case 'awarded':
      return <i className="fas fa-trophy larger-trophy me-5" />;
    case 'rejected':
      return <span className="text-muted label-text me-5">Not Accepted</span>;
    case 'invited':
      return <span className="text-primary label-text me-5">Invited</span>;
    default:
      return null;
  }
};

function ProjectStatusLabel({ status }) {
  return renderLabel(status);
}

ProjectStatusLabel.propTypes = {
  status: PropTypes.string.isRequired,
};

export default ProjectStatusLabel;
